import React from 'react';
import './EmptyCart.css';

const EmptyCart = () => (
    <div className="cart-empty">
     	<h1>You cart is empty</h1>
    </div>
  );

export default EmptyCart;
